import { z } from 'zod'

export const projectSchema = z.object({
  id: z.number(),
  category: z.string().nullable().optional(),
  topic: z.string().nullable().optional(),
  details: z.string().nullable().optional(),
  due_date: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  status: z.string(),
  created_at: z.string().nullable().optional(),
  created_by_id: z.number().nullable().optional(),
  deleted_at: z.string().nullable().optional(),
  archived_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
  collection: z.string().nullable().optional(),
})

const broadcastMetaSchema = z.object({
  id: z.string(),
  schema: z.string(),
  table: z.string(),
  operation: z.enum(['INSERT', 'UPDATE']),
  record: projectSchema.nullable(),
  old_record: projectSchema.nullable(),
})

export const projectBroadcastPayloadSchema = z.object({
  type: z.literal('broadcast'),
  event: z.enum(['INSERT', 'UPDATE']),
  payload: broadcastMetaSchema,
})
